jQuery(document).ready(function ($) {
  $('[data-vbg]').each(function () {
    $(this).youtube_background();
  });

});

